import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon TheatreDuotone
 */
export const TheatreDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M39.5,63.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0C27.3,68.9,32.7,63.4,39.5,63.4  M39.5,53.4c-12.3,0-22.2,10-22.2,22.3s10,22.2,22.2,22.2s22.2-10,22.2-22.2S51.8,53.4,39.5,53.4L39.5,53.4z"
      fill="currentColor"
    />
    <path
      d="M39.5,120.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C27.3,125.9,32.7,120.4,39.5,120.4 M39.5,110.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S51.8,110.4,39.5,110.4z"
      fill="currentColor"
    />
    <path
      d="M39.5,177.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C27.3,182.9,32.7,177.4,39.5,177.4 M39.5,167.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C61.8,177.3,51.8,167.4,39.5,167.4z"
      fill="currentColor"
    />
    <path
      d="M98.5,63.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C86.3,68.9,91.7,63.4,98.5,63.4 M98.5,53.4c-12.3,0-22.2,10-22.2,22.3s10,22.2,22.2,22.2s22.2-10,22.2-22.2S110.8,53.4,98.5,53.4 C98.5,53.4,98.5,53.4,98.5,53.4z"
      fill="currentColor"
    />
    <path
      d="M98.5,120.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C86.3,125.9,91.7,120.4,98.5,120.4 M98.5,110.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S110.8,110.4,98.5,110.4z"
      fill="currentColor"
    />
    <path
      d="M98.5,177.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C86.3,182.9,91.7,177.4,98.5,177.4 M98.5,167.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C120.8,177.3,110.8,167.4,98.5,167.4z"
      fill="currentColor"
    />
    <path
      d="M157.5,63.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C145.3,68.9,150.7,63.4,157.5,63.4 M157.5,53.4c-12.3,0-22.2,10-22.2,22.3s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C179.8,63.3,169.8,53.4,157.5,53.4z"
      fill="currentColor"
    />
    <path
      d="M157.5,120.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C145.3,125.9,150.7,120.4,157.5,120.4 M157.5,110.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S169.8,110.4,157.5,110.4z"
      fill="currentColor"
    />
    <path
      d="M157.5,177.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C145.3,182.9,150.7,177.4,157.5,177.4 M157.5,167.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C179.8,177.3,169.8,167.4,157.5,167.4z"
      fill="currentColor"
    />
    <path
      d="M216.5,63.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C204.3,68.9,209.7,63.4,216.5,63.4 M216.5,53.4c-12.3,0-22.2,10-22.2,22.3s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C238.8,63.3,228.8,53.4,216.5,53.4z"
      fill="currentColor"
    />
    <path
      d="M216.5,120.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C204.3,125.9,209.7,120.4,216.5,120.4 M216.5,110.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S228.8,110.4,216.5,110.4z"
      fill="currentColor"
    />
    <path
      d="M216.5,177.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C204.3,182.9,209.7,177.4,216.5,177.4 M216.5,167.4c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0 C238.8,177.3,228.8,167.4,216.5,167.4z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M39.5,63.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C27.3,68.9,32.7,63.4,39.5,63.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M39.5,120.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C27.3,125.9,32.7,120.4,39.5,120.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M39.5,177.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C27.3,182.9,32.7,177.4,39.5,177.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M98.5,63.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C86.3,68.9,91.7,63.4,98.5,63.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M98.5,120.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C86.3,125.9,91.7,120.4,98.5,120.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M98.5,177.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C86.3,182.9,91.7,177.4,98.5,177.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M157.5,63.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C145.3,68.9,150.7,63.4,157.5,63.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M157.5,120.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C145.3,125.9,150.7,120.4,157.5,120.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M157.5,177.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C145.3,182.9,150.7,177.4,157.5,177.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M216.5,63.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C204.3,68.9,209.7,63.4,216.5,63.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M216.5,120.4c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C204.3,125.9,209.7,120.4,216.5,120.4"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M216.5,177.4c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C204.3,182.9,209.7,177.4,216.5,177.4"
      fill="currentColor"
    />
    <rect height={10} width={127} x={67.3} y={9.1} />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default TheatreDuotone;
